export const ERR = {
  IE1001: '只能输入汉字或英文字母',
  IE1002: '请输入正确手机号',
  IE1003: '请输入正确字符',
  IE1004: '请输入正确证件信息',
  IE1005: '请输入正确邮箱',
  IE1006: '长度不能超过30且不能为符号',
  IE1007: '年龄不正确',
  IE1008: '开始时间不能大于等于结束时间',
  IE1009: '出生日期必须早于今天',
  IE1010: '身份证与基本信息中填写的的性别不一致',
  IE1011: '身份证与基本信息中填写的的生日不一致',
  IE1012: '长度限制为3-25位',
  IE1013: '长度限制为5-35位',
  IE1014: '证件号中的字母必须为大写',
  IE1015: '户口本请按客户户口簿身份证号码录入！',
  IE1016: '年龄大于16周岁不能选择户口本',
  IE1017: '出生证的证件号首字母必须为大写',
  IE1018: '与本人关系是子女时，才可以选择出生证',
  IE1019: '证件类型为护照，护照号码位数不能低于3个字符',
  IE1020: '请您输入有效的证件号码',
  IE1021: '姓名总长不多于50个汉字',
  IE1022: '姓名总长不多于50个字符',
  IE1023: '出生证仅限小于4周岁使用！',
  IE1024: '港澳居民居住证的证件号前4位应为8100或8200',
  IE1025: '台湾居民居住证的证件号前4位应为8300',
  IE1026: '证件类型非身份证、非户口本的证件类型、非港澳居民居住证、台湾居民居住证，不允许证件号码仍为15位或18位，不应符合身份证号相关的校验规则'
}


// WEBPACK FOOTER //
// ./src/pages/recruit/officeSaff/js/errCode.js